import React, { useState } from 'react';
import AdminLayout from '../../../layouts/AdminLayout';

const Services = () => {
    const [isAddServiceModalOpen, setIsAddServiceModalOpen] = useState(false);
    const [selectedService, setSelectedService] = useState("");
    const serviceOptions = [
        "Marketing",
        "Mobile Design",
        "UI/UX Design",
        "Software Development",
        "Product Management",
        "Customer Service",
        "Sales"
    ];

    return (
        <>
            <AdminLayout>
                <div className="ct_px_40 mt-4">
                    <div className="row">
                        <div className="col-lg-3 col-md-3 mb-4 mb-md-0">
                            <h4 className="mb-0 ct_fs_20 mb-4">Services</h4>
                            <div
                                className={`ct_filter_sidebar ct_custom_scroll p-0`}
                            >
                                <div className="mt-4">
                                    <h5 className="ct_fs_16 mb-3">Account Status</h5>
                                    <ul>
                                        <li>
                                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="flexCheckDefault"
                                                />
                                                <label for="" className="ct_text_clr_757886">
                                                    Active
                                                </label>
                                            </div>
                                        </li>
                                        <li className="mt-2">
                                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="flexCheckDefault"
                                                />
                                                <label for="" className="ct_text_clr_757886">
                                                    Suspended
                                                </label>
                                            </div>
                                        </li>
                                        <li className="mt-2">
                                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="flexCheckDefault"
                                                />
                                                <label for="" className="ct_text_clr_757886">
                                                    Pending Approval
                                                </label>
                                            </div>
                                        </li>
                                        <li className="mt-2">
                                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="flexCheckDefault"
                                                />
                                                <label for="" className="ct_text_clr_757886">
                                                    Deactivated
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div className="mt-4">
                                    <h5 className="ct_fs_16 mb-3">Activity Level</h5>
                                    <ul>
                                        <li>
                                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="flexCheckDefault"
                                                />
                                                <label for="" className="ct_text_clr_757886">
                                                    Last Active: Today
                                                </label>
                                            </div>
                                        </li>
                                        <li className="mt-2">
                                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="flexCheckDefault"
                                                />
                                                <label for="" className="ct_text_clr_757886">
                                                    Last 7 Days
                                                </label>
                                            </div>
                                        </li>
                                        <li className="mt-2">
                                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="flexCheckDefault"
                                                />
                                                <label for="" className="ct_text_clr_757886">
                                                    30+ Days Inactive
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div className="mt-4">
                                    <h5 className="ct_fs_16 mb-3">User Plan</h5>
                                    <ul>
                                        <li>
                                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="flexCheckDefault"
                                                />
                                                <label for="" className="ct_text_clr_757886">
                                                    Nuglow
                                                </label>
                                            </div>
                                        </li>
                                        <li className="mt-2">
                                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="flexCheckDefault"
                                                />
                                                <label for="" className="ct_text_clr_757886">
                                                    Nuforge
                                                </label>
                                            </div>
                                        </li>
                                        <li className="mt-2">
                                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="flexCheckDefault"
                                                />
                                                <label for="" className="ct_text_clr_757886">
                                                    Nustar
                                                </label>
                                            </div>
                                        </li>
                                        <li className="mt-2">
                                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="flexCheckDefault"
                                                />
                                                <label for="" className="ct_text_clr_757886">
                                                    Free
                                                </label>
                                            </div>
                                        </li>
                                        <li className="mt-2">
                                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="flexCheckDefault"
                                                />
                                                <label for="" className="ct_text_clr_757886">
                                                    Others
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div className="mt-4">
                                    <h5 className="ct_fs_16 mb-3">Flagged</h5>
                                    <ul>
                                        <li>
                                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="flexCheckDefault"
                                                />
                                                <label for="" className="ct_text_clr_757886">
                                                    Show Only Flagged Users
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-9 col-md-9 mb-4 mb-md-0">
                            <div className="d-flex align-items-center gap-3 justify-content-between mb-4 ct_flex_col_1199 pb">
                                <div>
                                    <h4 className="mb-0 ct_fs_20 mb-0">Manage Services</h4>
                                    <p className="mb-0 ct_text_clr_757886">
                                        View, filter, and take action across all Nuvio user types
                                    </p>
                                </div>
                                <div className="d-flex align-items-center gap-3 justify-content-end  ct_flex_col_575">
                                    {/* <div className="position-relative ct_w_100_575">
                                        <input
                                            type="text"
                                            className="form-control ct_input ct_h_35 ps-5"
                                            placeholder="Search by Name"
                                        />
                                        <i className="fa-solid fa-search ct_input_icon_left"></i>
                                    </div> */}
                                    <button
                                        className="ct_yellow_btn ct_h_35 ct_w_100_575"
                                        onClick={() => setIsAddServiceModalOpen(true)}
                                    >
                                        Add Services
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {isAddServiceModalOpen && (
                    <>
                        <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
                            <div className="modal-dialog modal-dialog-centered" role="document" style={{ maxWidth: "860px" }}>
                                <div className="modal-content border-0" style={{ borderRadius: "12px" }}>
                                    <div className="modal-body p-4 p-md-5 position-relative">
                                        <button
                                            type="button"
                                            aria-label="Close"
                                            onClick={() => {
                                                setIsAddServiceModalOpen(false);
                                                setSelectedService("");
                                            }}
                                            style={{
                                                width: "40px",
                                                height: "40px",
                                                borderRadius: "50%",
                                                border: "none",
                                                background: "#f0f0f0",
                                                position: "absolute",
                                                top: "16px",
                                                right: "16px",
                                                fontSize: "28px",
                                                lineHeight: "1",
                                            }}
                                        >
                                            &times;
                                        </button>
                                        <h4 className="text-center ct_fw_600 mt-4 mb-4">Select Service Type</h4>
                                        <div className="row g-3 g-md-4">
                                            {serviceOptions.map((service) => (
                                                <div key={service} className="col-lg-4 col-md-6 col-12">
                                                    <button
                                                        type="button"
                                                        className="w-100 border-0"
                                                        onClick={() => setSelectedService(service)}
                                                        style={{
                                                            borderRadius: "16px",
                                                            background: selectedService === service ? "#f5efe0" : "#f7f7f7",
                                                            border: selectedService === service ? "1px solid #ffb703" : "1px solid #e6e6e6",
                                                            minHeight: "140px",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            gap: "10px",
                                                        }}
                                                    >
                                                        <i className="fa-solid fa-layer-group" style={{ fontSize: "30px", color: "#1f2328" }}></i>
                                                        <span className="ct_fs_20">{service}</span>
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-backdrop fade show"></div>
                    </>
                )}
            </AdminLayout>
        </>
    )
};

export default Services;
